module.exports = __webpack_public_path__ + "static/media/grin-wink.a0edd9ab.svg";